import { render, staticRenderFns } from "./orderReport.vue?vue&type=template&id=149e2084&scoped=true&"
import script from "./orderReport.vue?vue&type=script&lang=js&"
export * from "./orderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149e2084",
  null
  
)

export default component.exports